import type { GetLatestResultsResponse } from "@/modules/api/generated-types/jobteaser/guidance/v1alpha1/guidance_tool"
import type { NextRequest } from "@/modules/fetch/types"
import type { ObjectToCamel } from "@/modules/format/types"

import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"

export type GuidanceToolsParams = {
  nextRequest?: NextRequest
}

const ENDPOINT = "/jobteaser.guidance.v1alpha1/GuidanceToolService/GetLatestResults"

export const getGuidanceTools = async ({
  nextRequest,
}: GuidanceToolsParams): Promise<ObjectToCamel<GetLatestResultsResponse>> => {
  return fetcher(ENDPOINT, {
    nextRequest,
    requestInit: {
      body: JSON.stringify({}),
      method: "POST",
    },
    serviceDomain: "APIGW_IN_KRAKEND_API",
  })
    .then(
      getResultFromResponse<GetLatestResultsResponse, ObjectToCamel<GetLatestResultsResponse>>({
        transformResult: toCamelCaseKeys,
      })
    )
    .catch(handleFetchError(ENDPOINT))
}
